//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Modal from "./Modal.vue";

export default {
  name: "Team",
  components: {
    Modal,
  },
  data() {
    return {
      videoModalOpen: false,
      selectedMember: {
        photoSrc: "",
      },
      teamMembers: [
        {
          id: 10,
          name: "Ambroise Couissin",
          title: "CEO & Founder",
          sub: "Technology",
          description1:
            "Ambroise is a tech veteran in the Hong Kong FinTech, InsurTech & HealthTech space.",
          description2:
            "Prior to founding Mazecare, Ambroise was the CTO of CoverGo. He also was the Head of Engineering and Lead Engineer in WealthTech companies such as Quantifeed and 8 Securities.",
          description3:
            "Ambroise holds a double MSc degree in Computer Sciences.",
          photoSrc: "/images/ambroise-couissin.jpg",
          linkedinUrl: "https://www.linkedin.com/in/ambroise-couissin/",
          twitterUrl: "https://twitter.com/acouissin",
        },
        // {
        //   id: 20,
        //   name: "Joshua Jenner",
        //   title: "Software Engineer",
        //   sub: "Technology",
        //   description1: "",
        //   photoSrc: "/images/joshua-jenner.jpg",
        //   linkedinUrl: "https://www.linkedin.com/in/joshuajennerdev/",
        // },
        // {
        //   id: 2,
        //   name: "Dr. Anthony Mak",
        //   sub: "Medical Expert | BM LMCHK FRCOphth MRCS (Ed)",
        //   title: "Advisor",
        //   description1: "",
        //   photoSrc: "/images/anthony-mak.png",
        // },
        // {
        //   id: 50,
        //   name: "Mesbaul Alam Khan",
        //   title: "Software Engineer",
        //   sub: "Technology",
        //   description1:
        //     "Mesbaul is a final year Computer Science student at the University of Hong Kong.",
        //   description2:
        //     "Prior to joining Mazecare, Mesbaul has interned at e-commerce startups and law tech firms, working at fast-paced environments with cutting edge technologies.",
        //   description3:
        //     "Mesbaul hopes to work as a software engineer upon graduation.",
        //   photoSrc: "https://i.ibb.co/Z1VQP8Y/Formal.jpg",
        //   linkedinUrl:
        //     "https://www.linkedin.com/in/mesbaul-alam-khan-87335b191/",
        //   facebook: "https://www.facebook.com/mesbaul.alam.52",
        //   email: "mesbaul.a.khan@gmail.com",
        // },
        // {
        //   id: 41,
        //   name: "Anshika Rajiv",
        //   title: "Software Engineer",
        //   sub: "Technology",
        //   description1:
        //     "Anshika is a student at the University of Hong Kong. She is majoring in Computer Science and minoring in Information Systems.",
        //   description2:
        //     "Prior to joining Mazecare, Anshika has worked and studied in India, Hong Kong, the Philippines, London, and Singapore in industries such as investment banking, fintech and consulting.",
        //   description3:
        //     "Anshika is passionate about software engineering and machine learning and aspires to work in these fields in the future.",
        //   photoSrc:
        //     "/images/anshika-rajiv.jpg",
        //   facebook: "https://www.facebook.com/anshika.rajiv/",
        //   email: "anshika.rajiv18@gmail.com"
        // },
        // {
        //   id: 21,
        //   name: "Cyrus Yan",
        //   title: "Software Engineer",
        //   sub: "Technology",
        //   description1: "",
        //   photoSrc: "/images/cyrus-yan.jpg",
        //   linkedinUrl: "https://www.linkedin.com/in/cyrus-yan-043239147/",
        // },
        {
          id: 23,
          name: "Gurpinder Singh",
          title: "Software Engineer",
          sub: "Technology",
          description1: "",
          photoSrc: "/images/gurpinder.jpg",
          linkedinUrl: "https://www.linkedin.com/in/gurpinder-singh-b16431207/",
        },
        {
          id: 24,
          name: "Sumit Kolhe",
          title: "Lead Software Engineer",
          sub: "Technology",
          description1: "",
          photoSrc: "/images/sumit-kolhe.jpg",
          linkedinUrl: "https://www.linkedin.com/in/sumitkolhe/",
        },
        {
          id: 25,
          name: "Willy Bernardus",
          title: "Software Engineer",
          sub: "Technology",
          description1:
            "Willy is a tech-savvy and a fresh graduate of the Purwadhika Digital Technology School majoring in Web and Mobile App Development",
          description2:
            "Before he switched his career to the Tech Industry. He has been working in music and audio engineering industry for over 5 years and holds a bachelor degree in Audio Production from Middlesex University, London. Currently, he is studying Product Management at Binar Academy.",
          description3:
            "He always curious about technology and is willing to gain more knowledges and experiences in software development",
          photoSrc: "/images/willy-bernardus.jpg",
          linkedinUrl: "https://www.linkedin.com/in/willy-bernardus/",
          twitterUrl: "https://twitter.com/willybernardus",
        },
        {
          id: 22,
          name: "Piyush Kautkar",
          title: "Software Engineer",
          sub: "Technology",
          description1:
            "Piyush is a tech-freak, a Software Engineer who likes to craft solid and scalable frontend products with great user experiences.",
          photoSrc: "/images/piyush.png",
          linkedinUrl: "https://www.linkedin.com/in/piyush-kautkar/",
          twitterUrl: "https://twitter.com/piyushkautkar",
        },
        {
          id: 27,
          name: "Ankit Hedau",
          title: "Software Engineer",
          sub: "Technology",
          description1:
            "Ankit Hedau is Electronics & Telecommunication Graduate from Pune University, India",
          description2:
            "Prior to joining Mazecare, Ankit has interned at Digital Wellness Platform and Telecommunications startup firms, working on User Interfaces technologies.",
          description3:
            "He is looking to enhance his skills and knowledge along with contributing to the growth of the organization.",
          photoSrc: "/images/ankit-hedau.png",
          linkedinUrl: "https://www.linkedin.com/in/ankit-hedau/",
        },
        // {
        //   id: 28,
        //   name: "Peggy Lam",
        //   title: "Engineer intern",
        //   sub: "Technology",
        //   description1: "New here.",
        //   photoSrc: "/images/peggy-lam.jpg",
        //   linkedinUrl: "https://www.linkedin.com/in/ka-hing-lam-422169206/",
        // },
        {
          id: 29,
          name: "Jeffrey Galvez",
          title: "Software Engineer",
          sub: "Technology",
          description1:
            "Jeffrey is a former high school math teacher turned web developer.",
          photoSrc: "/images/jeffrey-galvez.png",
          linkedinUrl: "https://www.linkedin.com/in/jeffrey-galvez-288518224/",
        },
        {
          id: 30,
          name: "John Michael Cuajotor",
          title: "Software Engineer",
          sub: "Technology",
          description1:
            "John is a career-shifter from the sales and marketing industry and now working as a software engineer for Mazecare.",
          photoSrc: "/images/jpcuajotor2.png",
          linkedinUrl: "https://www.linkedin.com/in/jm-cuajotor-b043771a7/",
        },
        {
          id: 31,
          name: "Suraj Narsale",
          title: "Software Engineer",
          sub: "Technology",
          description1:
            "Suraj is a technophile and a final-year student at Pune University, India",
          description2:
            "He has a craving for creating experienced designs, apps & sites with amazing user experience.",
          photoSrc: "/images/suraj-narsale.png",
          linkedinUrl: "https://www.linkedin.com/in/surajnarsale/",
        },
        {
          id: 32,
          name: "Almas Utami",
          title: "Software Engineer",
          sub: "Technology",
          description1:
            "Almas learned Fullstack Web and Mobile Development from Purwadhika Digital Technology School",
          description2:
            "She graduated form Bandung Institute of Technology, Indonesia, majoring in Geothermal Engineering for her master degree",
          description3:
            "Shifting career, she yearn to be a Software Engineer who can deliver good insights to fulfil company needs.",
          photoSrc: "/images/almas-utami.jpg",
          linkedinUrl: "https://www.linkedin.com/in/almas-utami-a7938598/",
        },
        {
          id: 33,
          name: "Nadhif Rafifaiz",
          title: "Software Engineer",
          sub: "Technology",
          description1:
            "Nadhif is a computer science graduate that passionate about website development, design, and technology",
          description2:
            "He graduated from Gunadarma University, Indonesia, and continue his study at Purwadhika Digital Technology School to persue his passion in website development",
          description3:
            "He aspires to create well design software and a healthy work environment for fellow developers",
          photoSrc: "/images/nadhif-rafifaiz.jpg",
          linkedinUrl: "https://www.linkedin.com/in/nadhif-rafifaiz-07581b179/",
        },
        {
          id: 34,
          name: "Venkatesh Chakrabarty",
          title: "Software Engineer",
          sub: "Technology",
          description1:
            "Venkatesh is a final year student of Computer Science and Engineering at KIIT University, India.",
          description2:
            "He is passionate about technology and web development with focus on User Experience.",
          photoSrc: "/images/venkatesh-chakrabarty.jpg",
          linkedinUrl: "https://www.linkedin.com/in/venkateshch59/",
          twitterUrl: "https://twitter.com/venkatexh",
        },
        {
          id: 35,
          name: "Meet Mistry",
          title: "Frontend Engineer",
          sub: "Technology",
          description1:
            "Meet is a Techie and pre-final year student of Computer Science and Engineering at Indus University, India.",
          description2:
            "He is always curious about technology and has special focus on Frontend Web Development.",
          photoSrc: "/images/meet-mistry.jpg",
          linkedinUrl: "https://www.linkedin.com/in/meet-mistry/",
          twitterUrl: "https://twitter.com/its_meeeet",
        },
        // {
        //   id: 36,
        //   name: "Omraj Sharma",
        //   title: "Software Engineer",
        //   sub: "Technology",
        //   description1:
        //     "Omraj is a prefinal year engineering student at MAIT Delhi, India.",
        //   description2:
        //     "He is passionate about products and technologies with focus on user interface and experience.",
        //   photoSrc: "/images/omraj-sharma.png",
        //   linkedinUrl: "https://www.linkedin.com/in/omraj-sharma/",
        //   twitterUrl: "https://twitter.com/om_raj_sharma",
        // },
        {
          id: 37,
          name: "Stanley Ang",
          title: "Software Engineer",
          sub: "Technology",
          description1:
            "Stanley is a software engineer from Indonesia graduating from the School of Computer Science at BINUS University, with specialization of Mobile Application and Technology.",
          description2:
            "He's been using the computer since he was 8. He has a passion for technology and is always looking to learn more.",
          photoSrc: "/images/stanley.jpg",
          linkedinUrl: "https://www.linkedin.com/in/angsanley",
          twitterUrl: "https://twitter.com/angsanley",
        },
        // {
        //   id: 38,
        //   name: "Emmanuel Koech",
        //   title: "Software Engineer",
        //   sub: "Technology",
        //   description1:
        //     "Meet Emmanuel, a software engineer passionate about emerging technologies. He is keen to provision fast, secure and reliable web technologies that solve real life problems.",
        //   photoSrc: "/images/Emmanuel.jpeg",
        //   linkedinUrl: "https://www.linkedin.com/in/emmanuel-koech-9952b2122/",
        // },
        {
          id: 39,
          name: "Arpit Patni",
          title: "Software Engineer",
          sub: "Technology",
          description1: "A passionate Software Engineer",
          photoSrc: "/images/arpit-patni.jpg",
          linkedinUrl: "https://www.linkedin.com/in/thearpitpatni/",
        },
        {
          id: 40,
          name: "Kuldeep Gupta",
          title: "Software Engineer",
          sub: "Technology",
          description1:
            "Kuldeep is a final year undergrad at Galgotias University, India. He loves to code, build projects and always open to feedbacks to improve more and learn more! ",
          photoSrc: "/images/kuldeep-gupta.jpg",
          linkedinUrl: "https://www.linkedin.com/in/devdeadviz/",
          twitterUrl: "https://twitter.com/devdeadviz",
        },
        {
          id: 41,
          name: "Kashika Jain",
          title: "Software Engineer",
          sub: "Technology",
          description1:
            "Kashika is a final year Computer Science undergraduate at MAIT,delhi",
          description2:
            "She is an enthusiastic and passionate Software Engineer who believes technology can empower and solve real world problems",
          photoSrc: "/images/kashika-jain.jpeg",
          linkedinUrl: "https://www.linkedin.com/in/kashika-jain-180393195/",
          twitterUrl: "https://twitter.com/KashikaJain31",
        },

        {
          id: 42,
          name: "Sayali Kale",
          title: "Software Engineer",
          sub: "Technology",
          photoSrc: "/images/sayali.jpg",
          linkedinUrl: "https://www.linkedin.com/in/sayali-kale-a17b971a2/",
        },
        {
          id: 43,
          name: "Ranita Saha",
          title: "Software Engineer",
          sub: "Technology",
          description1:
            "A science and engineering enthusiast, passionate about learning and trying out new technologies",
          photoSrc: "/images/ranita-saha.jpg",
          linkedinUrl: "https://www.linkedin.com/in/saharanitaa1230dreamer/",
          twitterUrl: "https://twitter.com/Ifullofsunshine",
        },
        {
          id: 44,
          name: "Harsh Jain",
          title: "Software Engineer",
          sub: "Technology",
          description1:
            "Harsh is a final year Computer Science undergrad at GGSIPU Delhi",
          photoSrc: "/images/Harsh-jain.jpg",
          linkedinUrl: "https://www.linkedin.com/in/harsh-jain-8953191a8/",
        },
        {
          id: 45,
          name: "Hana Widyatari",
          title: "Software Engineer",
          sub: "Technology",
          description1: "Hana learned as Fullstack web from Binar Academy ",
          description2:
            "She graduated from Institute Technology of Sepuluh Nopember, Indonesia. she loves to code and design web. Always learning and gaining her exploration to enhance her skills.",
          photoSrc: "/images/hanaw.jpg",
          linkedinUrl: "https://www.linkedin.com/in/hana-widyatari/",
        },
        {
          id: 46,
          name: "Ashar Ardianto",
          title: "Software Engineer",
          sub: "Technology",
          description1:
            "Ashar is a graduate from University of Indonesia. He recently graduated from Binar Academy majoring in Full-Stack Web Development",
          description2:
            "He has a high interest in the field of web development which made him decide to shift his career to become a software engineer",
          photoSrc: "/images/ashar-ardianto.jpg",
          linkedinUrl: "https://www.linkedin.com/in/ashar-ardianto-247489193/",
        },
        {
          id: 47,
          name: "Sami Kalammallah",
          title: "Software Engineer",
          sub: "Technology",
          description1:
            "Sami is a family man from Indonesia who graduate from Binar Academy majoring in a Full Stack Web Development.",
          description2:
            "Raised from the IT environtment, led him to loves computer and stuffs about it. After graduate from collage as a Bachelor Degree of English Educations, He decide to switch his career to becoma a software engineer by learn things from internet including joining a bootcamp academy.",
          description3:
            "He also loves to play pc games, known as tech geek and a bit car guy.",
          photoSrc: "/images/sami-kalammallah.png",
          linkedinUrl: "https://www.linkedin.com/in/samikalammallah/",
          twitterUrl: "https://twitter.com/Kalammallah23",
        },
        {
          id: 48,
          name: "Sedana Yoga",
          title: "Software Engineer",
          sub: "Technology",
          description1:
            "Don't have CS degree instead I took Biomedical Engineering at college",
          description2:
            "Started career in QA role but be extremely thrilled with Web Development stuff, mainly in Frontend part.",
          description3: "In spare time, enjoying movies and hiking.",
          photoSrc: "/images/sedana-yoga.png",
          linkedinUrl: "https://www.linkedin.com/in/sedanayoga/",
          twitterUrl: "https://twitter.com/cok_yoga",
        },
        {
          id: 49,
          name: "Cahya Adi Utama",
          title: "Software Engineer",
          sub: "Technology",
          description1:
            "He is on a journey to pursue his passion in software engineering, with a focus on front-end development and design. He has a strong desire to learn and grow, and is always open to constructive feedback from everyone.",
          photoSrc: "/images/cahya-adi.png",
          linkedinUrl:
            "https://www.linkedin.com/in/i-dewa-gede-cahya-adi-utama-43380b247/",
        },
        {
          id: 50,
          name: "Calvin Antonius",
          title: "Software Engineer",
          sub: "Technology",
          description1:
            "Graduated from Bina Nusantara University studying Computer Science.",
          description2: "Likes learning and using interesting technologies.",
          photoSrc: "/images/calvin-anto.jpg",
          twitterUrl: "https://twitter.com/calvinanto/",
        },
        {
          id: 51,
          name: "Riya Gabriel Liu",
          title: "Software Engineer",
          sub: "Technology",
          description1:
            "I am Riya Gabriel Liu new software engineer i am from Indonesia Kalimantan Barat or West Borneo.",
          description2:
            "I enjoy learning new things and applying the experience and skills I have gained in my career",
          photoSrc: "/images/riya-gabriel-liu.jpeg",
          linkedinUrl:
            "https://www.linkedin.com/in/riya-gabriel-liu-37a108234/",
        },
        {
          id: 52,
          name: "Saurabh Jadhav",
          title: "Software Engineer",
          sub: "Technology",
          description1:
            "Saurabh is a recent Information Technology graduate from Pune University, who has a passion for creating visually appealing designs, apps, and websites with exceptional user experience.",
          description2:
            "He is excited to bring their skills and creativity to our team.",
          photoSrc: "/images/Saurabh-Jadhav.jpg",
          linkedinUrl: "https://www.linkedin.com/in/saurabhvj16/",
        },
        {
          id: 53,
          name: "Akash Kute",
          title: "Software Engineer",
          sub: "Technology",
          description1:
            "Akash is a technophile, who has a passion for crafting intuitive user interfaces and delivering seamless user experiences.",
          description2:
            "Prior to joining Mazecare, Akash was helping The Designer's Class to develope innovative products.",
          photoSrc: "/images/akash-kute.png",
          linkedinUrl: "https://www.linkedin.com/in/akash-kute/",
        },
        {
          id: 54,
          name: "Ryan Fadhilah",
          title: "Software Engineer",
          sub: "Technology",
          description1: "",
          description2: "",
          photoSrc: "/images/ryan-fadhilah.jpeg",
          linkedinUrl: "https://www.linkedin.com/in/ryan-fadhilah-03146918a/",
        },
        {
          id: 55,
          name: "Yashoda Agarwal",
          title: "Software Engineer",
          sub: "Technology",
          description1: "",
          description2: "",
          photoSrc: "/images/yashoda-agarwal.jpg",
          linkedinUrl: "https://www.linkedin.com/in/yashodaagarwal/",
        },
        {
          id: 56,
          name: "Ayush Mishra",
          title: "Software Engineer",
          sub: "Technology",
          description1:
            "Ayush is a seasoned frontend developer with extensive expertise in diverse frontend technologies, crafting intuitive user interfaces and seamless experiences.",
          description2:
            "He is excited to bring their skills and creativity to our team.",
          photoSrc: "/images/Ayush-Mishra.jpg",
          linkedinUrl: "https://www.linkedin.com/in/ayush-mishra2000/",
        },
        {
          id: 57,
          name: "Envrico Tjhen",
          title: "Software Engineer",
          sub: "Technology",
          description1:
            "Envrico is a dedicated software engineer, mostly do full stack and like back end.",
          description2:
            "Fun fact: Envrico started coding and has had his own blog since he was 9 years old.",
          photoSrc: "/images/envrico.jpg",
          linkedinUrl: "https://www.linkedin.com/in/envrico-tjhen/",
        },
        {
          id: 58,
          name: "Yolanda Ihsan",
          title: "Software Engineer",
          sub: "Technology",
          description1: "Oan is a happy developer.",
          description2:
            "He started his career in Web Development in 2018. He was graduated from Politeknik Caltex Riau in Informatics Engineering major. Mostly using Javascript.",
          description3:
            "He likes to learn new technologies and helping people.",
          photoSrc: "/images/yolandaihsan.jpg",
          linkedinUrl: "https://www.linkedin.com/in/yolandaihsan/",
        },
        {
          id: 59,
          name: "Arian Nurrahman",
          title: "Software Engineer",
          sub: "Technology",
          description1:
            "A passionate software engineer who specializes in front-end development.",
          description2: "",
          description3: "",
          photoSrc: "/images/arian-nurrahman.jpg",
          linkedinUrl: "https://www.linkedin.com/in/arian-nurrahman/",
        },
        {
          id: 60,
          name: "Mochamad Rafli",
          title: "Software Engineer",
          sub: "Technology",
          description1:
            "Rafli is self lernner developer who very interested in Web Development.",
          description2:
            "Since graduate from highschool he always interested in programming, starting from learning automation now he is focusing on Fullstack Web Development",
          description3:
            "He is also like Doing a lot of DIY Stuff and like to learn new things.",
          photoSrc: "/images/mochamad-rafli.jpg",
          linkedinUrl: "https://www.linkedin.com/in/mochamad-rafli/",
        },
        {
          id: 61,
          name: "Suprianto Djamalu",
          title: "Software Engineer",
          sub: "Technology",
          description1:
            "Front-end developer with a passion for creating intuitive and visually appealing user interfaces.",
          description2: "",
          description3: "",
          photoSrc: "/images/suprianto-djamalu.jpg",
          linkedinUrl: "https://www.linkedin.com/in/erthru/",
        },
        {
          id: 62,
          name: "Yazid Nurfadil",
          title: "Software Engineer",
          sub: "Technology",
          description1: "Drama-Free Software Engineer",
          description2:
            "A Tech-Savvy dad who loves transforming family life with code and compassion.",
          description3: "",
          photoSrc: "/images/yazid-nurfadil.jpg",
          linkedinUrl: "https://www.linkedin.com/in/yazidnurfadil/",
        },
        {
          id: 63,
          name: "Kamiswara Angga",
          title: "Software Engineer",
          sub: "Technology",
          description1:
            "A seasoned professional with over four years of hands-on experience in web development.",
          description2: "",
          description3: "",
          photoSrc: "/images/kamiswara-angga.jpeg",
          linkedinUrl: "https://www.linkedin.com/in/anggakswr/",
        },
        {
          id: 64,
          name: "Rafi Putra",
          title: "Software Engineer",
          sub: "Technology",
          description1: "Love desing and tech",
          description2: "",
          description3: "",
          photoSrc: "/images/rafi-p.png",
          linkedinUrl: "https://www.linkedin.com/in/rafi-panji/",
        },
        {
          id: 65,
          name: "Yeremia Chris Saragi",
          title: "Software Engineer",
          sub: "Technology",
          description1:
            "A software engineer with a passion for building scalable and efficient systems.",
          description2: "",
          description3: "",
          photoSrc: "/images/yeremia.jpg",
          linkedinUrl: "https://www.linkedin.com/in/yeremia-chris-saragi",
        },
      ],
      advisors: [
        {
          id: 55,
          name: "Stephane Louvrier",
          title: "Advisor",
          sub: "Health Insurance Expert",
          description1:
            "Stephane is an executive with extensive experience in Insurance, HealthCare, and Consulting industries, having worked for start-ups as well as Global Fortune 500 companies.",
          description2:
            "Within Health Insurance, his expertise is on digital solutions, operational efficiency, and commercial development.",
          description3:
            "Stephane is an investor and advisor of tech related start-ups and supports Mazecare in its development.",
          photoSrc: "/images/stephane-louvrier.jpeg",
          linkedinUrl: "https://www.linkedin.com/in/stephanelouvrier/",
        },
        {
          id: 56,
          name: "Valter Santos Matos",
          title: "Advisor",
          sub: "Tech Expert",
          description1:
            "Valter is an experienced IT Director with proven leadership and full-stack technical skills in the finance industry.",
          description2:
            "He lead and implementend numerous projects from the customer needs & user experience, to backend services.",
          description3:
            "Valter has MEng degree in Electrical and Computer Engineering",
          photoSrc: "/images/valter-santos-matos.jpeg",
          linkedinUrl: "https://www.linkedin.com/in/valtermatos/",
          twitterUrl: "https://twitter.com/valter_s_matos",
        },
        {
          id: 57,
          name: "Jacob Sacuto",
          title: "Advisor",
          sub: "Health Insurance Expert",
          description1: "Jacob has 15 years experience in health insurance.",
          description2:
            "He has worked on both sides of the fence: from advising and servicing customers with a broker to working with a health insurer on various areas including claim management and product development.",
          photoSrc: "/images/jacob-sacuto.jpg",
          linkedinUrl: "https://www.linkedin.com/in/jacobsacuto/",
        },
        {
          id: 58,
          name: "Oliver Carter",
          title: "Advisor",
          sub: "Product Expert",
          photoSrc: "/images/oliver-carter.jpg",
          linkedinUrl: "https://www.linkedin.com/in/oliverthomascarter/",
        },

        {
          id: 59,
          name: "John Ho",
          title: "Advisor",
          sub: "Medical Doctor丨former investment banker丨Oxford-trained engineer",
          description1: "",
          photoSrc: "/images/john-ho.jpg",
          linkedinUrl: "https://www.linkedin.com/in/imjohnho/",
        },
        {
          id: 60,
          name: "Filipa Pinto",
          title: "Advisor",
          sub: "Medical Expert",
          description1: "",
          photoSrc: "/images/filipa-pinto.jpg",
          linkedinUrl: "https://www.linkedin.com/in/filipafonsecapinto/",
        },
        {
          id: 80,
          name: "Medhy Souidi",
          title: "Advisor",
          sub: "Head of FinTech, StartupXchange & Customer Development at DBS | What the FinTech | Keynote Speaker",
          description1:
            "Medhy Souidi has been instrumental in leveraging digital technology to transform DBS Bank into the Digital Bank of Singapore. His StartupXchange programme has matched 70 startups with colleagues across DBS, rolling out more than 25 emerging technology solutions.",
          description2:
            "Medhy himself is big on the fintech scene as a regular speaker at major industry events and a member of the Fintech Association of Hong Kong. In 2019, Asian Private Banker named him Fintech Changemaker of the Year. Tatler recognized him as Gen T, one of the young leaders shaping Asia’s future in Finance and Technology.",
          description3:
            "Medhy is the founder and producer of the social media series WhatTheFinTech, a series of short videos offering insight, news and views on FinTech and the latest innovations. He also writes a weekly newsletter for 15,000 people at: https://www.linkedin.com/pulse/what-fintech-weekly-update-28-feb-2021-medhy-souidi",
          photoSrc: "/images/medhy-souidi.jpeg",
          linkedinUrl: "https://www.linkedin.com/in/medhysouidi/",
          twitterUrl: "https://twitter.com/medhy_souidi",
        },
        {
          id: 90,
          name: "Youssef El Kaddioui",
          title: "Advisor",
          sub: "Founder/CEO @TheScalelab.io | Forbes 30 under 30 | Lead Generation & Customer Acquisition Expert",
          photoSrc: "/images/youssef-el-kaddioui.jpg",
          linkedinUrl: "https://www.linkedin.com/in/youssefelkaddioui/",
          twitterUrl: "https://twitter.com/_youss",
        },
        {
          id: 100,
          name: "Phoebe Yeung",
          title: "Creative Director",
          photoSrc: "/images/phoebe-yeung.jpg",
          linkedinUrl: "https://www.linkedin.com/in/phoebe-yeung-97a87396/",
        },
      ],
    };
  },
};
